import { Checkbox } from '@bedrock/components';
import { useUpdateEffect } from 'ahooks';
import React from 'react';

function Head({ onSelectChange, data = [], selectedRows, rowKey }) {

  const validateData = data.filter((item) => {
    return !item?.$addRow
  })

  const handleAllCheckChange = (e) => {
    e.stopPropagation();
    const checked = e.target.checked;
    if (checked) {
      onSelectChange(validateData);
      return;
    }
    onSelectChange([]);
  }

  useUpdateEffect(() => {
    const newSelectRows = selectedRows.filter(item => data?.find(el => el?.[rowKey] === item?.[rowKey]));
    if (newSelectRows?.length !== selectedRows?.length) {
      onSelectChange(newSelectRows);
    }
  }, [data])

  const indeterminate = !!selectedRows?.length;

  const allChecked = indeterminate && validateData?.length === selectedRows?.length

  return <Checkbox indeterminate={indeterminate} onChange={handleAllCheckChange} checked={allChecked} />
}

function Row({ onSelectChange, selectedRows, record, rowKey }) {

  const handleCheckChange = (e) => {
    e.stopPropagation();
    const checked = e.target.checked;
    if (checked) {
      onSelectChange([...selectedRows, record]);
      return;
    }
    onSelectChange(selectedRows.filter(item => item[rowKey] !== record?.[rowKey]))
  }

  return <Checkbox onChange={handleCheckChange} checked={selectedRows.find(item => item[rowKey] === record?.[rowKey])} />
}

export default {
  Head,
  Row,
}